<template>
  <footer class="footer-container">
    <div class="footer-content">
      <!-- 
        target="_blank" 表示在新标签页中打开链接
        请将 "京ICP备xxxxxxxx号-x" 替换为你自己的备案号
      -->
	  <div style="font-size: 12px;color: #999;">
		广西共勉科技有限公司
	  </div>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        备案号：桂ICP备2025077324号-1
      </a>
      <!-- <p class="copyright">© 2025 Your Company Name. All Rights Reserved.</p> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="less" scoped>
.footer-container {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  background-color: #f8f8f8; /* 可以根据你的主题色调整 */
  border-top: 1px solid #e7e7e7;
  margin-top: 10px; /* 与上方内容保持一定距离 */
}

.footer-content a {
  font-size: 12px;
  color: #999;
  text-decoration: none; /* 去掉链接下划线 */
}

.footer-content a:hover {
  color: #333; /* 鼠标悬停时颜色加深 */
}

.copyright {
  margin-top: 8px;
  font-size: 12px;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/base/footer.vue